import 'regenerator-runtime/runtime';
import './assets/scss/resources.scss';

import { resourceTile } from './building-blocks/tiles/resource-tile/resource-tile.module';
import { resourcesCenter } from './building-blocks/resources-center/resources-center.module';
import { favoritesList } from './building-blocks/favorites-list/favorites-list.module';
import { header } from './building-blocks/header/header.module';
import { filter } from './building-blocks/filter/filter.module';
import { helpStickyButton } from './components/help-sticky-button/help-sticky-button.module';

export { favoritesList } from './building-blocks/favorites-list/favorites-list.module';
/**
 * Initializes all components on the current page and optionally listens for changes in the DOM to initialize
 * dynamically created objects later on.
 * @param observe Boolean if all components should listen for changes in the DOM and initialize dynamically added
 *   components
 */
const initializeAllComponentsResources = (observe): void => {
    resourceTile.initializeAll(observe);
    resourcesCenter.initializeAll(observe);
    favoritesList.initializeAll(observe);
    header.initializeAll(observe);
    filter.initializeAll(observe);
    helpStickyButton.initializeAll(observe);
};

/**
 * Waits for document content loaded event and initializes all javascript controls.
 */
document.addEventListener('DOMContentLoaded', () => {
    if (!document.body.getAttribute('data-resources-initialized')) {
        initializeAllComponentsResources(true);
        document.body.setAttribute('data-resources-initialized', 'true');
    }
});
